import React from "react";
import { motion } from "framer-motion";
import { awards } from "../../data/award";

export default function AwardsAbout() {
  return (
    <div className="w-full bg-white ">
      {/* Section Header */}
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl font-bold text-[#0F172A]">Awards & Recognitions</h2>
        <div className="w-20 h-1 bg-[#C9A227] mx-auto mt-2 rounded-full"></div>
        <p className="text-gray-700 mt-4 text-lg max-w-3xl mx-auto leading-relaxed">
          Our dedication to excellence has earned us prestigious accolades in the legal industry. Here are some of our notable awards.
        </p>
      </motion.div>

      {/* Awards Grid */}
      <motion.div
        className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        {awards.map((award, index) => (
          <motion.div
            key={index}
            className="bg-gray-100 p-6 rounded-lg shadow-lg text-center flex flex-col items-center"
            whileHover={{ scale: 1.05 }}
          >
            <img
              src={award.image}
              alt={award.title}
              className="w-32 h-32 object-cover rounded-lg border-4 border-[#C9A227] shadow-md"
            />
            <h3 className="text-xl font-bold text-[#0F172A] mt-4">{award.title}</h3>
            <p className="text-gray-700 mt-2 leading-relaxed">{award.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
